import {Button, Grid, Paper, Typography} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import {useNavigate, useParams} from "react-router-dom";
import {FormProvider, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {useTheftMisappropriationActions} from "../../service/useTheftMisappropriationActions";
import {ArrowBack} from "@mui/icons-material";
import TheftMisappropriationDetailsTab from "./TheftMisappropriationDetailsTab";
import {ITheftMisappropriate} from "../../component/TheftMisappropriationInterfaces";
import {useRecoilState} from "recoil";
import {EDITING} from "../../service/FinesSecurityRecoil";
import {
    DECIMAL_REG_EXP,
    STATUS_FOUND,
    STATUS_NOT_FOUND,
    STATUS_RECOVERED,
    STATUS_RELEASE,
    STATUS_UNDER_SEIZURE
} from "../../component/Constants";

const TheftMisappropriationDetail = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const navigate = useNavigate();
    const {id} = useParams();
    const backToList = "/finessecurity/theft-misappropriation";
    const [theftMisappropriate, setTheftMisappropriate] = useState<ITheftMisappropriate | null>(null);
    const {getTheftMisappropriationDetail} = useTheftMisappropriationActions();
    const [editing, setEditing] = useRecoilState(EDITING);

    useEffect(() => {
        if (id) {
            getTheftMisappropriationDetail(id).then(res => {
                setTheftMisappropriate(res);
            });
        }
    }, []);

    useEffect(() => {
        if (theftMisappropriate) {
            form.reset(retrieveInitialValues());
        }
    }, [theftMisappropriate])


    const retrieveInitialValues = () => {
        if (theftMisappropriate) {
            return {
                id: theftMisappropriate.id ? theftMisappropriate.id : "",
                // ITDRIV-22446 / LPP-24225: rentalAgreement e customerId governano hasChargeableSubject()
                // in InvoicingDetails (switch "da addebitare"). Vanno idratati nel form anche in modifica,
                // altrimenti watch() li legge undefined e lo switch resta sempre disabilitato pur avendo
                // la scheda RA e/o cliente valorizzati a DB.
                rentalAgreement: theftMisappropriate.rentalAgreement ? theftMisappropriate.rentalAgreement : "",
                customerId: theftMisappropriate.customerId ? theftMisappropriate.customerId : "",
                eventType: theftMisappropriate.eventType ? theftMisappropriate.eventType : "",
                residualDays: theftMisappropriate.residualDays ? theftMisappropriate.residualDays : "",
                daysFromRelease: theftMisappropriate.daysFromRelease ? theftMisappropriate.daysFromRelease : "",
                entryUser: theftMisappropriate.entryUser ? theftMisappropriate.entryUser : "",
                openingDatetime: theftMisappropriate.openingDatetime ? theftMisappropriate.openingDatetime : null,
                closingDatetime: theftMisappropriate.closingDatetime ? theftMisappropriate.closingDatetime : null,
                eventStatus: theftMisappropriate.eventStatus ? theftMisappropriate.eventStatus : "",
                lostOfPossession: theftMisappropriate.lostOfPossession ? theftMisappropriate.lostOfPossession : "",
                carRecovery: theftMisappropriate.carRecovery ? theftMisappropriate.carRecovery : "",

                toBeCharged: theftMisappropriate.toBeCharged ? theftMisappropriate.toBeCharged : false,
                sentToInvoice: theftMisappropriate.sentToInvoice ? theftMisappropriate.sentToInvoice : false,
                billed: theftMisappropriate.billed ? theftMisappropriate.billed : false,
                invoiceAmount: theftMisappropriate.invoiceAmount ? theftMisappropriate.invoiceAmount : "",
                invoiceDatetime: theftMisappropriate.invoiceDatetime ? theftMisappropriate.invoiceDatetime : null,
                penaltyAmount: theftMisappropriate.penaltyAmount ? theftMisappropriate.penaltyAmount : "",
                coverageType: theftMisappropriate.coverageType ? theftMisappropriate.coverageType : "",
                chargeableTheftExcess: theftMisappropriate.chargeableTheftExcess != null ? theftMisappropriate.chargeableTheftExcess : null,

                eventCountry: theftMisappropriate.eventCountry ? theftMisappropriate.eventCountry : "",
                eventRegion: theftMisappropriate.eventRegion ? theftMisappropriate.eventRegion : "",
                eventCity: theftMisappropriate.eventCity ? theftMisappropriate.eventCity : "",
                eventProvince: theftMisappropriate.eventProvince ? theftMisappropriate.eventProvince : "",
                eventAddress: theftMisappropriate.eventAddress ? theftMisappropriate.eventAddress : "",
                eventDatetime: theftMisappropriate.eventDatetime ? theftMisappropriate.eventDatetime : null,
                complaintDatetime: theftMisappropriate.complaintDatetime ? theftMisappropriate.complaintDatetime : null,
                complaintAuthority: theftMisappropriate.complaintAuthority ? theftMisappropriate.complaintAuthority : "",
                prosecutionNumber: theftMisappropriate.prosecutionNumber ? theftMisappropriate.prosecutionNumber : "",

                placeCountry: theftMisappropriate.placeCountry ? theftMisappropriate.placeCountry : "",
                placeRegion: theftMisappropriate.placeRegion ? theftMisappropriate.placeRegion : "",
                placeCity: theftMisappropriate.placeCity ? theftMisappropriate.placeCity : "",
                placeAddress: theftMisappropriate.placeAddress ? theftMisappropriate.placeAddress : "",
                placeFoundDatetime: theftMisappropriate.placeFoundDatetime ? theftMisappropriate.placeFoundDatetime : null,
                placeReportOfReturnDatetime: theftMisappropriate.placeReportOfReturnDatetime ? theftMisappropriate.placeReportOfReturnDatetime : null,
                placeReleaseDatetime: theftMisappropriate.placeReleaseDatetime ? theftMisappropriate.placeReleaseDatetime : null,
                underSeizureDatetime: theftMisappropriate.underSeizureDatetime ? theftMisappropriate.underSeizureDatetime : null,
                reportAuthority: theftMisappropriate.reportAuthority ? theftMisappropriate.reportAuthority : "",

                differentComplaint: !!(theftMisappropriate.complaintFirstName && theftMisappropriate.complaintLastName),
                complaintFirstName: theftMisappropriate.complaintFirstName ? theftMisappropriate.complaintFirstName : "",
                complaintLastName: theftMisappropriate.complaintLastName ? theftMisappropriate.complaintLastName : "",
                complaintDelivery: !!theftMisappropriate.complaintDeliveryDatetime,
                complaintDeliveryDatetime: theftMisappropriate.complaintDeliveryDatetime ? theftMisappropriate.complaintDeliveryDatetime : null,
                keyDelivery: !!theftMisappropriate.keyDeliveryDatetime,
                keyDeliveryDatetime: theftMisappropriate.keyDeliveryDatetime ? theftMisappropriate.keyDeliveryDatetime : null,
                complaintKeyDelivery: !!theftMisappropriate.complaintKeyDeliveryDatetime,
                complaintKeyDeliveryDatetime: theftMisappropriate.complaintKeyDeliveryDatetime ? theftMisappropriate.complaintKeyDeliveryDatetime : null,
                lossOfPossession: !!theftMisappropriate.lossOfPossessionDatetime,
                lossOfPossessionDatetime: theftMisappropriate.lossOfPossessionDatetime ? theftMisappropriate.lossOfPossessionDatetime : null,

                notes: theftMisappropriate.notes ? theftMisappropriate.notes : "",
                isWreck: theftMisappropriate.isWreck != null ? theftMisappropriate.isWreck : null,
                attachments: theftMisappropriate.attachments ? theftMisappropriate.attachments : [],
                complaintAttachments: theftMisappropriate.complaintAttachments ? theftMisappropriate.complaintAttachments : []
            };
        } else {
            return {
                id: "",
                rentalAgreement: "",
                customerId: "",
                eventType: {eventTypeCode: ""},
                residualDays: "",
                daysFromRelease: "",
                entryUser: "",
                openingDatetime: null,
                closingDatetime: null,
                eventStatus: {eventStatusCode: ""},
                lostOfPossession: "",
                carRecovery: "",
                toBeCharged: false,
                sentToInvoice: false,
                billed: false,
                invoiceAmount: "",
                invoiceDatetime: null,
                penaltyAmount: "",
                eventCountry: "",
                eventRegion: "",
                eventCity: "",
                eventAddress: "",
                eventDatetime: null,
                complaintDatetime: null,
                complaintAuthority: "",
                prosecutionNumber: "",
                placeCountry: "",
                placeRegion: "",
                placeCity: "",
                placeAddress: "",
                placeFoundDatetime: null,
                placeReportOfReturnDatetime: null,
                placeReleaseDatetime: null,
                underSeizureDatetime: null,
                reportAuthority: "",
                differentComplaint: false,
                complaintFirstName: "",
                complaintLastName: "",
                complaintDelivery: false,
                complaintDeliveryDatetime: null,
                keyDelivery: false,
                keyDeliveryDatetime: null,
                complaintKeyDelivery: false,
                complaintKeyDeliveryDatetime: null,
                lossOfPossession: false,
                lossOfPossessionDatetime: null,
                notes: "",
                isWreck: null,
                attachments: [],
                complaintAttachments: []
            };
        }

    }

    const validationSchema = Yup.object({
        complaintDatetime: Yup.date().required(t('updateForm.requiredCheck')).nullable().typeError(t('updateForm.invalidDate')),
        eventDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')),
        placeFoundDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')).test("placeFoundDatetime", t('updateForm.requiredCheck'),
            (value, context) => {
                return ((context.parent.eventStatus && context.parent.eventStatus.eventStatusCode !== STATUS_FOUND) ||
                    (!!value && context.parent.eventStatus.eventStatusCode === STATUS_FOUND))
            }),
        placeReportOfReturnDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')),
        placeReleaseDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')).test("placeReleaseDatetime", t('updateForm.requiredCheck'),
            (value, context) => {
                return ((context.parent.eventStatus && context.parent.eventStatus.eventStatusCode !== STATUS_RELEASE) ||
                    (!!value && context.parent.eventStatus.eventStatusCode === STATUS_RELEASE))
            }),
        underSeizureDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')).test("placeUnderSeizureDatetime", t('updateForm.requiredCheck'),
            (value, context) => {
                return ((context.parent.eventStatus && context.parent.eventStatus.eventStatusCode !== STATUS_UNDER_SEIZURE) ||
                    (!!value && context.parent.eventStatus.eventStatusCode === STATUS_UNDER_SEIZURE))
            }),
        invoiceAmount: Yup.string().matches(DECIMAL_REG_EXP, {
            excludeEmptyString: true,
            message: t('updateForm.onlyDecimalNumbers')
        }),
        complaintFirstName: Yup.string().nullable().test("complaintFirstName", t('updateForm.requiredCheck'),
            (value, context) => {
                return (!context.parent.differentComplaint || (value && context.parent.differentComplaint))
            }).typeError(t(' updateForm.requiredCheck')),
        complaintLastName: Yup.string().nullable().test("complaintLastName", t('updateForm.requiredCheck'),
            (value, context) => {
                return (!context.parent.differentComplaint || (value && context.parent.differentComplaint))
            }).typeError(t(' updateForm.requiredCheck')),
        complaintDeliveryDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')).test("complaintDeliveryDatetime", t('updateForm.requiredCheck'),
            (value, context) => {
                return (!context.parent.complaintDelivery || (value && context.parent.complaintDelivery))
            }),
        keyDeliveryDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')).test("keyDeliveryDatetime", t('updateForm.requiredCheck'),
            (value, context) => {
                return (!context.parent.keyDelivery || (value && context.parent.keyDelivery))
            }),
        complaintKeyDeliveryDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate')).test("complaintKeyDeliveryDatetime", t('updateForm.requiredCheck'),
            (value, context) => {
                return (!context.parent.complaintKeyDelivery || (value && context.parent.complaintKeyDelivery))
            }),
        lossOfPossessionDatetime: Yup.date().nullable().typeError(t('updateForm.invalidDate'))
            .test("lossOfPossessionDatetime", t('updateForm.requiredCheck'),
                (value, context) => {
                    //return (context.parent.eventStatus.eventStatusCode !== STATUS_NOT_FOUND || (value && context.parent.lossOfPossession &&
                    //    context.parent.eventStatus.eventStatusCode === STATUS_NOT_FOUND))
                    return true;
                }),
        isWreck: Yup.boolean().nullable()
            .test("isWreck", t('updateForm.requiredCheck'),
                (value, context) => {
                    return (context.parent.eventStatus.eventStatusCode !== STATUS_RECOVERED || (value != null && context.parent.eventStatus.eventStatusCode === STATUS_RECOVERED))
                }),
    });

    const form = useForm({
        defaultValues: retrieveInitialValues(),
        resolver: yupResolver(validationSchema),
    });

    return (
        <>
            <SectionHeader title={t('listHeader.title')}
                           subtitle={t('listHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                <Grid>
                    {editing ?
                        <Typography  variant={"button"}>
                            {theftMisappropriate?.eventType.eventTypeCode === 0 ?
                                t('listHeader.theftCardMod', {plate: theftMisappropriate?.plate}) :
                                    theftMisappropriate?.eventType.eventTypeCode === 1
                                        ? t('listHeader.misapprCardMod', {plate: theftMisappropriate?.plate}) : ""}
                        </Typography>
                        :

                        <Typography>
                            {theftMisappropriate?.eventType.eventTypeCode === 0 ?
                                t('listHeader.theftCard', {plate: theftMisappropriate?.plate}) :
                                theftMisappropriate?.eventType.eventTypeCode === 1
                                    ? t('listHeader.misapprCard', {plate: theftMisappropriate?.plate}) : ""}
                        </Typography>
                    }

                </Grid>
                <FormProvider {...form}>
                    <TheftMisappropriationDetailsTab id={id} setTheftMisappropriate={setTheftMisappropriate}
                                                     theftMisappropriate={theftMisappropriate}/>
                </FormProvider>

            </Paper>
        </>
    );

}
export default TheftMisappropriationDetail;